import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import QuickStartGuide from '../components/QuickStartGuide';
import { trackMarketingEvent } from '../lib/marketingEvents';
import useTheme4A from '../components/useTheme4A';

// Public, unauthenticated 60-second product tour.
// Linked from the marketing site via /api/partner/promo -> tour_url.
// On finish/skip, send visitors to the landing page (which has the sign-up CTA).
export default function PublicTourPage() {
  useTheme4A();
  const navigate = useNavigate();

  useEffect(() => {
    trackMarketingEvent('tour_view');
  }, []);

  const handleComplete = () => {
    trackMarketingEvent('tour_complete');
    navigate('/landing', { replace: true });
  };

  return (
    <div data-testid="public-tour-page">
      <QuickStartGuide onComplete={handleComplete} autoPlay />
    </div>
  );
}
